import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Attachment } from '@/types/attachment';

export function useEstimateAttachments(estimateId: string) {
  return useApiQuery<Attachment[]>({
    queryKey: estimateKeys.attachments(estimateId),
    queryFn: () =>
      apiGet<Attachment[]>(operationsClient, opsEstimateEndpoints.attachments(estimateId)),
    enabled: Boolean(estimateId),
  });
}
